export default __webpack_public_path__ + "static/media/kjm.3a76559f.png";